export enum TaxiCorporationPlanEntryBillingsRequestOrder {
  DISTANCE_ASC = "DISTANCE_ASC",
  DISTANCE_DESC = "DISTANCE_DESC",
  HIGHWAY_CHARGE_ASC = "HIGHWAY_CHARGE_ASC",
  HIGHWAY_CHARGE_DESC = "HIGHWAY_CHARGE_DESC",
  HUMAN_ID_ASC = "HUMAN_ID_ASC",
  HUMAN_ID_DESC = "HUMAN_ID_DESC",
  DRIVER_ASC = "DRIVER_ASC",
  DRIVER_DESC = "DRIVER_DESC",
  BILLING_MODEL_ASC = "BILLING_MODEL_ASC",
  BILLING_MODEL_DESC = "BILLING_MODEL_DESC",
  DISTANCE_RATE_ASC = "DISTANCE_RATE_ASC",
  DISTANCE_RATE_DESC = "DISTANCE_RATE_DESC",
  DISTANCE_AMOUNT_ASC = "DISTANCE_AMOUNT_ASC",
  DISTANCE_AMOUNT_DESC = "DISTANCE_AMOUNT_DESC",
  TOTAL_AMOUNT_ASC = "TOTAL_AMOUNT_ASC",
  TOTAL_AMOUNT_DESC = "TOTAL_AMOUNT_DESC",
}

export enum TaxiCorporationPlanEntryBillingsRequestBillingModel {
  AB = "AB",
  ABA = "ABA",
  OTHER = "OTHER",
  SABS = "SABS",
}

export type TaxiCorporationPlanEntryBillingsRequestQueryParams = {
  limit: number;
  offset: number;
  order?: TaxiCorporationPlanEntryBillingsRequestOrder;
  humanId?: string;
  dateSince?: string;
  dateTo?: string;
  driver?: string;
  billingModel?: TaxiCorporationPlanEntryBillingsRequestBillingModel;
  fleetPartner?: string;
  cargoOrderHumanId?: number;
};

type TaxiCorporationPlanEntryBillingsRequest = {
  taxiCorporationUuid: string;
  limit: number;
  offset: number;
  order?: TaxiCorporationPlanEntryBillingsRequestOrder;
  humanId?: string;
  dateSince?: string;
  dateTo?: string;
  driver?: string;
  billingModel?: TaxiCorporationPlanEntryBillingsRequestBillingModel;
  fleetPartner?: string;
  cargoOrderHumanId?: number;
};

export default TaxiCorporationPlanEntryBillingsRequest;
